import { SequenceHelper } from "@swivl-mono/helpers";
import { LocationVarKey, SequenceEnabledStatus, SequenceInterface, SequenceSubType } from "@swivl-mono/types";
import { OptionsHelper } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  InputRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";

export default function WorksheetView() {
  const { sequences } = SequencesModel.useState();
  const page = usePropertiesGetLocationIds();
  useEffect(() => {
    SequencesModel.load(false);
  }, []);
  const sequenceArray: SequenceInterface[] | undefined = useMemo(() => {
    if (sequences) {
      return Object.values(sequences);
    }
    return undefined;
  }, [sequences]);

  return (
    <>
      <PageHeader {...page} subheading="These sync with your FMS daily and will trigger a workflow to communicate with your leads who express interest in a unit but haven't rented.">Abandoned Cart Sequences</PageHeader>
      <SwitchRow {...page} keyName={LocationVarKey.WantsCronReceiptsAbandonedCarts} label="Send Email Receipts" />
      <SwitchRow {...page} keyName={LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled} label="Use Shortlinks" />
      <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.WhichFMS, "StorEdge")} keyName={LocationVarKey.HasScheduleLeadsForMessages} label="Schedule all leads in StorEdge for messages" />


      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_01, sequenceArray) && (
        <>
          <SectionHeader {...page}>1 day after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay01ActuallyEnabled}
            options={[
              { label: "Enabled", value: "ENABLED" },
              { label: "Disabled", value: "DISABLED" },
              { label: "Simulated", value: "SIMULATED" },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay01Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay01TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp1AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp1AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp1AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp1AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp1AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp1AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp1AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp1AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp1AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp1AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp1AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}


      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_02, sequenceArray) && (
        <>
          <SectionHeader {...page}>2 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay02Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay02Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay02TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp2AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp2AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp2AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp2AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp2AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp2AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp2AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp2AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp2AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp2AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp2AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_03, sequenceArray) && (
        <>
          <SectionHeader {...page}>3 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay03Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay03Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay03TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp3AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp3AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp3AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp3AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp3AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp3AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp3AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp3AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp3AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp3AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp3AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_05, sequenceArray) && (
        <>
          <SectionHeader {...page}>5 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay05Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay05Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay05TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp5AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp5AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp5AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp5AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp5AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp5AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp5AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp5AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp5AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp5AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp5AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_07, sequenceArray) && (
        <>
          <SectionHeader {...page}>7 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay07Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay07Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay07TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp7AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp7AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp7AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp7AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp7AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp7AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp7AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp7AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp7AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp7AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp7AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_10, sequenceArray) && (
        <>
          <SectionHeader {...page}>10 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay10Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay10Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay10TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp10AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp10AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp10AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp10AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp10AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp10AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp10AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp10AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp10AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp10AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp10AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_14, sequenceArray) && (
        <>
          <SectionHeader {...page}>14 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay14Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay14Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay14TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp14AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp14AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp14AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp14AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp14AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp14AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp14AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp14AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp14AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp14AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp14AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_30, sequenceArray) && (
        <>
          <SectionHeader {...page}>30 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay30Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay30Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay30TimeInUTC}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")} keyName={LocationVarKey.FMSplusp30AbandonedCartVoiceEnabled} label="Voice" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp30AbandonedCartSMSEnabled} label="SMS" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartSMSEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp30AbandonedCartSMSShortlink} label="SMS Link to Shorten" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp30AbandonedCartEmailEnabled} label="Email" />
            <InputRow {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartEmailEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")])} keyName={LocationVarKey.FMSplusp30AbandonedCartEmailShortlink} label="Email Link to Shorten" />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp30AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp30AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp30AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp30AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp30AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp30AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}
    </>
  );
}
